import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-infrastructure',
  templateUrl: './cloud-infrastructure.component.html',
  styleUrls: ['./cloud-infrastructure.component.css']
})
export class CloudInfrastructureComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/cloud-infrastructure/cloud-infrastructure.component.ts